// src/hooks/useStatsAnimation.ts
import { useState, useEffect } from 'react';

interface AnimationState {
    today: boolean;
    week: boolean;
    month: boolean;
    history: boolean;
    lastAnimationTime: number;
}

const ANIMATION_COOLDOWN = 10 * 60 * 1000; // 10 minutos em ms
const STORAGE_KEY = 'graia-stats-animation';

export const useStatsAnimation = () => {
    const [animationState, setAnimationState] = useState<AnimationState>(() => {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            try {
                return JSON.parse(stored);
            } catch {
                return {
                    today: false,
                    week: false,
                    month: false,
                    history: false,
                    lastAnimationTime: 0
                };
            }
        }
        return {
            today: false,
            week: false,
            month: false,
            history: false,
            lastAnimationTime: 0
        };
    });

    // Salvar no localStorage sempre que mudar
    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(animationState));
    }, [animationState]);

    const canAnimate = (): boolean => {
        const now = Date.now();
        return now - animationState.lastAnimationTime > ANIMATION_COOLDOWN;
    };

    const markAnimated = (view: 'today' | 'week' | 'month' | 'history') => {
        setAnimationState(prev => ({
            ...prev,
            [view]: true,
            lastAnimationTime: Date.now()
        }));
    };

    const shouldAnimate = (view: 'today' | 'week' | 'month' | 'history'): boolean => {
        return !animationState[view] && canAnimate();
    };

    return {
        shouldAnimate,
        markAnimated,
        canAnimate
    };
};